import { Creator } from '@/models/creator';

export const PLATFORM_EXAMPLES: Record<Creator.PlatformOptions, string> = {
  youtube: 'youtube.com/@name, youtube.com/channel/UCxx, youtube.com/user/name',
  instagram: 'instagram.com/name',
  tiktok: 'tiktok.com/@name'
};
